<!-- 二级多选组件 -->
<template>
<div class="multipleSelect">
    <!-- 一级 -->
    <ul class="selectList">
        <li
            class="item"
            :class="{'active':!selected.length}"
            @click="selectAll(1)">
            不限
        </li>
        <li
            class="item"
            :class="{'active':selected[0]==option[valueKey]}"
            v-for="(option,index) in selection"
            :key="index"
            @click="selectOption(option,1)">
            {{option[labelKey]}}
        </li>
    </ul>
    <!-- 二级 -->
    <ul class="subSelectList" v-if="showSubOpt">
        <li
            class="item"
            :class="{'active':selected.length==1}"
            @click="selectAll(2)">
            不限
        </li>
        <li
            class="item"
            :class="{'active':selected[1]==option[valueKey]}"
            v-for="(option,index) in subOptions"
            :key="index"
            @click="selectOption(option,2)">
            {{option[labelKey]}}
        </li>
    </ul>
</div>
</template>

<script>
    export default {
        data() {
            return {
                selected:[],//[一级,二级,...] 最终值选择最后一个
                showSubOpt:false,
                subOptions:[],
            }
        },
        watch: {
            selectedProp(){
                // console.log(111,this.selectedProp)
                this.selected=this.selectedProp
            }
        },
        props:{
            selection:{//选项
                type:Array,
                default(){
                    return [];
                }
            },
            selectedProp:{//已选项
                type:Array,
                default(){
                    return [];//默认不限
                }
            },
            labelKey:{//展示的label的key名称，根据接口调整
                type:String,
                default(){
                    return 'label';
                }
            },
            valueKey:{//value的key名称，根据接口调整
                type:String,
                default(){
                    return 'value';
                }
            },
            paramKey:{//传参约定的key名称，根据接口调整
                type:String,
                default(){
                    return '';
                }
            },
        },
        computed: {
            selectedObj(){
                return {
                    key:this.paramKey,
                    data:this.selected
                }
            }
        },
        created() {
            this.selected=this.selectedProp
        },
        methods: {
            selectOption(opt,level){
                
                switch(level){
                    case 1://第一级
                        // 设置此时选择的值
                        this.selected=[opt[this.valueKey]]
                        // 如果有子集，展示子集选项栏
                        if(opt.aChild&&opt.aChild.length){
                            this.showSubOpt=true;
                            this.subOptions=opt.aChild
                        }else{
                            this.showSubOpt=false;
                            this.subOptions=[]
                        }
                        break;
                    case 2://第一级 设置selected的第二个位置的值为所选值
                        this.$set(this.selected,level-1,opt[this.valueKey])
                        break;
                }

                this.$emit('selectOption',this.selectedObj);
            },
            // 选择不限
            selectAll(level){
                switch(level){
                    case 1://第一级 置空selected 
                        this.selected=[]
                        this.showSubOpt=false
                        this.subOptions=[]
                        break;
                    case 2://第二级 删除selected的第二个位置的值 
                        this.selected.splice(level-1,1)
                        break;
                }
                this.$emit('selectOption',this.selectedObj);
            }
        }
    }
</script>

<style lang="scss" scoped>
.page .formBox .selectList .item,
.page .formBox .subSelectList .item{
    padding: 0 .1rem;
}
</style>
